import { handleApiError } from '@/handleApiError'
import { isGuest } from '@/helpers'
import { LiveUpdateState } from '@/modules/eventStream/types'
import useEventStream from '@/modules/eventStream/useEventStream'
import api from '@/modules/quote/api'
import { QuoteActivity } from '@/types/index'
import { defineStore } from 'pinia'

interface QuoteActivityState extends LiveUpdateState {
  activityEntries: QuoteActivity[]
  loading: boolean
  sending: boolean
}

const initialState = (): QuoteActivityState => {
  return {
    activityEntries: [],
    updateStream: undefined,
    streamTimeOut: undefined,
    loading: false,
    sending: false
  }
}

const useQuotes = defineStore('quoteActivity', {
  state: () => initialState(),
  actions: {
    async getActivityEntries(quoteId: string, backgroundLoading = false, openStream = true) {
      this.loading = !backgroundLoading

      return api
        .getActivityEntries(quoteId, isGuest.value)
        .then(({ data }) => {
          this.activityEntries = data
          if (openStream) {
            this.openActivitiesEntriesUpdateStream(quoteId, isGuest.value)
          }
        })
        .catch(handleApiError)
        .finally(() => {
          this.loading = false
        })
    },
    openActivitiesEntriesUpdateStream(id: string, isGuest = false) {
      useEventStream.openStream(
        this.$state as LiveUpdateState,
        api.getActivityEntriesUpdateStreamPath(id, isGuest),
        (update: QuoteActivity[]) => (this.activityEntries = update),
        () => this.getActivityEntries(id, true, false)
      )
    },
    closeActivitiesEntriesUpdateStream() {
      useEventStream.closeStream(this.$state as LiveUpdateState)
    },
    async addActivityEntry(quoteId: string, comment: string) {
      this.sending = true

      return api
        .addActivityEntry(quoteId, { value: comment }, isGuest.value)
        .then(() => {
          this.getActivityEntries(quoteId, true)
        })
        .catch(handleApiError)
        .finally(() => {
          this.sending = false
        })
    }
  }
})

export default useQuotes
